export const ru = {
    'about-price': 'Подробнее о ценах в объявлениях',
    'editor-cancel-action': 'Отменить',
    'editor-clear-fields-action': 'Очистить поля',
    'editor-save-action': 'Сохранить',
    'price-hint-text':
        'Укажите цену вашего товара, чтобы попасть в товарную галерею. Не забудьте загрузить изображения. {helpUrl}'
};
